import { Record, Union } from "../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, option_type, class_type, string_type, bool_type, union_type } from "../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Account_UserInfo_$reflection, Account_OtpActivation_$reflection } from "../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.4.19.0/Result.js";
import { Remote$1, Remote$1_$reflection, GlobalMsg_$reflection } from "../../../Bfs.Web.Portale/Types.fs.js";
import { ValidationRule, FormField_Init_Z1F39563A, FormField__get_IsValid, FormField_$reflection } from "../../../Bfs.Web.Portale/Validation.fs.js";

export class Page extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["PasswordChange"];
    }
}

export function Page_$reflection() {
    return union_type("Profile.Types.Page", [], Page, () => [[]]);
}

export class OtpMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DeactivateOtpCheckboxChanged", "OtpChanged", "ActivateOtp", "ActivationLoaded", "ConfirmOtp", "ConfirmationLoaded", "DeactivateOtp", "DeactivationLoaded"];
    }
}

export function OtpMsg_$reflection() {
    return union_type("Profile.Types.OtpMsg", [], OtpMsg, () => [[["Item", bool_type]], [["Item", string_type]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Account_OtpActivation_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Account_OtpActivation_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]]]);
}

export class PasswordMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["OldPasswordChanged", "NewPassword1Changed", "NewPassword2Changed", "SubmitPassword", "PasswordReqeustDone"];
    }
}

export function PasswordMsg_$reflection() {
    return union_type("Profile.Types.PasswordMsg", [], PasswordMsg, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", class_type("System.Exception")]]])]]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadUserInfo", "UserInfoLoaded", "Otp", "Password", "GlobalMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("Profile.Types.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Account_UserInfo_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Account_UserInfo_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", OtpMsg_$reflection()]], [["Item", PasswordMsg_$reflection()]], [["Item", GlobalMsg_$reflection()]]]);
}

export class OtpStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["OtpDeactivated", "OtpActivating", "OtpActivated"];
    }
}

export function OtpStatus_$reflection() {
    return union_type("Profile.Types.OtpStatus", [], OtpStatus, () => [[], [], [["ShouldDeactivate", bool_type]]]);
}

export class OtpModel extends Record {
    constructor(Status, OtpField, ErrorMsg, Secret, QrCode) {
        super();
        this.Status = Status;
        this.OtpField = OtpField;
        this.ErrorMsg = ErrorMsg;
        this.Secret = Secret;
        this.QrCode = QrCode;
    }
}

export function OtpModel_$reflection() {
    return record_type("Profile.Types.OtpModel", [], OtpModel, () => [["Status", OtpStatus_$reflection()], ["OtpField", FormField_$reflection()], ["ErrorMsg", option_type(string_type)], ["Secret", string_type], ["QrCode", string_type]]);
}

export function OtpModel__get_CanSubmit(x) {
    return FormField__get_IsValid(x.OtpField);
}

export class PasswordModel extends Record {
    constructor(OldPassword, NewPassword1, NewPassword2, ErrorMsg, OkMsg) {
        super();
        this.OldPassword = OldPassword;
        this.NewPassword1 = NewPassword1;
        this.NewPassword2 = NewPassword2;
        this.ErrorMsg = ErrorMsg;
        this.OkMsg = OkMsg;
    }
}

export function PasswordModel_$reflection() {
    return record_type("Profile.Types.PasswordModel", [], PasswordModel, () => [["OldPassword", FormField_$reflection()], ["NewPassword1", FormField_$reflection()], ["NewPassword2", FormField_$reflection()], ["ErrorMsg", option_type(string_type)], ["OkMsg", option_type(string_type)]]);
}

export function PasswordModel__get_CanSubmit(x) {
    if (FormField__get_IsValid(x.OldPassword) && FormField__get_IsValid(x.NewPassword1)) {
        return FormField__get_IsValid(x.NewPassword2);
    }
    else {
        return false;
    }
}

export function PasswordModel_Init_6DFDD678(okMsg) {
    return new PasswordModel(FormField_Init_Z1F39563A(new ValidationRule(0, [])), FormField_Init_Z1F39563A(new ValidationRule(0, [])), FormField_Init_Z1F39563A(new ValidationRule(0, [])), undefined, okMsg);
}

export class Model extends Record {
    constructor(Name, UserInfo, Otp, Password) {
        super();
        this.Name = Name;
        this.UserInfo = UserInfo;
        this.Otp = Otp;
        this.Password = Password;
    }
}

export function Model_$reflection() {
    return record_type("Profile.Types.Model", [], Model, () => [["Name", string_type], ["UserInfo", Remote$1_$reflection(Account_UserInfo_$reflection())], ["Otp", option_type(OtpModel_$reflection())], ["Password", option_type(PasswordModel_$reflection())]]);
}

export function Model_InitPassword_Z721C83C5(name) {
    return new Model(name, new Remote$1(1, []), new OtpModel(new OtpStatus(0, []), FormField_Init_Z1F39563A(new ValidationRule(0, [])), undefined, "", ""), PasswordModel_Init_6DFDD678(undefined));
}

//# sourceMappingURL=Types.fs.js.map
